export default __webpack_public_path__ + "static/media/Superman_05.58aa0557.png";